import type { Method } from 'axios';

const md5 = require('md5');

export const publicEncrypt = (parmas: {
  hasSearchParamsPath: string;
  bodyToYY?: string; // 有的yy 不是整体转换，需要特殊处理
  method?: Method;
  time: string | number;
  body?: any;
}) => {
  const { hasSearchParamsPath, bodyToYY, method, time, body } = parmas;
  // 只有post才传body
  let encryptBody = {};
  if (method && method.toLocaleLowerCase() === 'post') {
    encryptBody = body || {};
  }
  encryptBody = JSON.stringify(encryptBody);

  if (bodyToYY) {
    encryptBody = bodyToYY;
  }

  const combinedEncrypt =
    encodeURIComponent(hasSearchParamsPath) + '_' + encryptBody + md5(time.toString()) + 'ooui';

  return md5(combinedEncrypt);
};

// 语音sse 接口yy 文件前 1024 & publicEncrypt
export const handleTelSseFetchEncrypt = (
  pathname: string,
  time: string,
  body: { characterID: string; chatID: string; file: File },
) => {
  return new Promise((resolve) => {
    try {
      const reader = new FileReader();
      // 读取文件的前 1024 字节
      const blob = body.file?.slice(0, 1024);
      reader.readAsArrayBuffer(blob);
      reader.onload = (event) => {
        const fileArray = new Uint8Array(event.target?.result as any);
        const fileToMD5 = md5(fileArray);
        const yyBody = md5(body?.characterID) + md5(body?.chatID) + fileToMD5;

        const encryptResult = publicEncrypt({
          hasSearchParamsPath: pathname,
          bodyToYY: yyBody,
          time: time,
        });

        resolve(encryptResult);
      };
      reader.onerror = () => {
        resolve('');
      };
    } catch (err) {
      resolve('');
    }
  });
};

// 声音复刻 yy 加密规则 双层加密 md5(md5(file 前 1024字节))
export const handleRecordEncrypt = (file: File) => {
  return new Promise((resolve) => {
    try {
      const reader = new FileReader();
      const blob = file?.slice(0, 1024);
      reader.readAsArrayBuffer(blob);
      reader.onload = (event) => {
        const fileArray = new Uint8Array(event.target?.result as any);
        resolve(md5(fileArray));
      };
      reader.onerror = () => {
        resolve('');
      };
    } catch (err) {
      resolve('');
    }
  });
};

// 文字消息 yy
export const handleSendTextSseFetchEncrypt = (pathname: string, time: string, bodyMd5: any) => {
  const encryptResult = publicEncrypt({
    hasSearchParamsPath: pathname,
    bodyToYY: bodyMd5,
    time: time,
  });
  return encryptResult;
};
